import { useBasePath } from './use-base-path';
import { useGenericBi } from './use-generic-bi';
import { markNavFromDrawer } from './drawer-nav';
import { useLeaveChatOnNavigate } from './use-leave-chat';
import { useTranslation } from './i18n';

export interface SettingsCardLink {
  route: string;
  path: string;
  label: string;
  onClick: () => void;
}

/**
 * The drawer/rail credits card's body destination — Settings, opened with the same
 * `openedFromDrawer` marker native uses (`markNavFromDrawer`), so a Settings screen reached from
 * here keeps the MENU affordance instead of flipping to BACK (see the callers for the full story).
 *
 * Shared by the ordinary credits card (`useCreditsSummary`'s `account` field) and the low/out
 * widget (`CreditsMenuWidget`) so both variants of the same card slot open the same place, the same
 * way — extracted because the widget renders standalone (no `CreditsSummary` behind it, since a
 * daily-pool low/out state can fire while the period meter — and so `useCreditsSummary` — is null).
 */
export function useSettingsCardLink(): SettingsCardLink {
  const { t } = useTranslation();
  const basePath = useBasePath();
  const leaveChat = useLeaveChatOnNavigate();
  const { logPageClickBi } = useGenericBi();
  return {
    route: '/settings',
    path: `${basePath}/settings`,
    label: t('nav.settings'),
    onClick: () => {
      markNavFromDrawer();
      logPageClickBi({ page_name: 'menu', button_name: 'drawer_credits_card', origin: 'menu' });
      leaveChat();
    },
  };
}
